import { ADMIN_FETCH_USERS, FETCH_CUSTOMER_PERMISSIONS } from '../actions/actionTypes'; 

const initialState = {
    adminUsers: [],
    customerPermissions: [],
}

const adminReducer = (state = initialState, action) => {
    //console.log('AdminReducer adminReducer called action: ' + JSON.stringify(action.payload)); 

    switch(action.type){
        case ADMIN_FETCH_USERS:
            return {
                ...state,
                adminUsers: action.payload
            }
        case FETCH_CUSTOMER_PERMISSIONS:
            return {
                ...state,
                customerPermissions: action.payload
            }          
        default:
            return state;
    }
}


export { adminReducer };